import { render, staticRenderFns } from "./FixedIncomeProducts.vue?vue&type=template&id=3a7b9e78&scoped=true"
import script from "./FixedIncomeProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./FixedIncomeProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FixedIncomeProducts.vue?vue&type=style&index=0&id=3a7b9e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b9e78",
  null
  
)

export default component.exports